'use client';

import { useQuery } from '@tanstack/react-query';

import { hasReceivedPaymentBonus } from 'src/utils/plan/plan-bonus';

import { fsCall } from 'src/actions/firestore/dispatch';
import { workspaceKeys } from 'src/query-keys/workspace';

// ----------------------------------------------------------------------

/**
 * 그 워크스페이스가 첫 결제 보너스(무료 1달)를 이미 받았는가 — 결제 내역(`payment.history.get`) 중 `bonus` 가 적힌 것이 있는가.
 * 결제 화면 · 요금 화면 · 체험 띠 · 만료 화면이 함께 쓴다. 판정의 정본은 서버(`server/payment/payment-bonus`)다.
 * ⚠️ 읽기에 실패하면 «받았다»(`true`)로 접는다 — 혜택을 약속하지 않는 쪽이다(서버도 못 읽으면 주지 않는다).
 *   그래서 `throwOnError` 로 묻는다 — 기본 갈래는 실패를 빈 목록으로 삼켜 «안 받았다»로 읽힌다.
 *
 * @param workspaceId 비면 묻지 않는다
 * @returns 아직 모르면(읽는 중 · 묻지 않음) `undefined`
 */
export function usePaymentBonusUsed(workspaceId: string | null | undefined): boolean | undefined {
  const id = String(workspaceId ?? '').trim();
  const query = useQuery({
    queryKey: workspaceKeys.paymentBonusUsed(id),
    enabled: Boolean(id),
    staleTime: 60_000,
    retry: 1,
    queryFn: async () => hasReceivedPaymentBonus(await fsCall('payment.history.get', { workspaceId: id, throwOnError: true })),
  });
  if (!id) return undefined;
  return query.isError ? true : query.data;
}
